import { render, staticRenderFns } from "./Porte.vue?vue&type=template&id=48cc7442&"
import script from "./Porte.vue?vue&type=script&lang=js&"
export * from "./Porte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports